import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { providePrimeNG } from 'primeng/config';

import { AppRoutingModule } from 'editing-tool/src/app/app-routing.module';
import { AppComponent } from 'editing-tool/src/app/app.component';
import { CoreModule } from 'editing-tool/src/app/core/core.module';
import { LayoutModule } from 'editing-tool/src/app/modules/layout/layout.module';
import { SharedModule } from 'editing-tool/src/app/shared/shared.module';
import ExternalThemePreset from 'sc-external/themes/external-theme-preset';

@NgModule({
    declarations: [
        AppComponent
    ],
    bootstrap:
        [AppComponent],
    imports: [BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,
        CoreModule,
        LayoutModule,
        SharedModule],
    providers: [
        provideHttpClient(withInterceptorsFromDi()),
        providePrimeNG({
            theme: {
                preset: ExternalThemePreset,
                options: {
                    darkModeSelector: false
                }
            },
            ripple: false
        })
    ]
})
export class AppModule { }

